module.exports = __webpack_public_path__ + "static/img/zhouye01.77f918b8.jpg";